module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_7042.190167d6.png";